import { styled } from 'baseui'

export const SectionCardContainer = styled('div', {
  backgroundColor: '#fff',
  borderRadius: '0.5rem',
  border: '0.0625rem solid #E6EAF2',
  padding: '0.85rem',
  boxSizing: 'border-box',
})
